import { RestaurantCardElement } from './RestaurantCardElement';

export const RestaurantCardList = ({ items = [], filter = 0, userdata = null }) => {


    if (filter === 1) {
        items = items.filter(elem => elem.reservable === false);
    } else if (filter === 2) {
        items = items.filter(elem => elem.reservable === true);
    }

    return (<>
        {
            items.map((item, index) => {

                return (<RestaurantCardElement key={'room_' + index} {...item} userdata={userdata} />)
            })
        }
    </>);
};
